import {Props} from './types';
import logoImage from '../logoL.png';


const View = (props: Props) => (
  <div className='bg-gray'>

    {/* Logo */}
    <div className='row'>
      <div className='pt-2 px-4'>
        <a href="https://linfer-inc.jp/" className="no-underline">
          <img src={logoImage} alt="Linfer-Logo" style={{width: 35}}/>
        </a>
      </div>
    </div>

    <div className='d-flex align-items-center flex-column text-color'>

      {/* Title */}
      <div className="mt-3 mb-4">
        <h1 className="text-title-color">
          Location Search and Mapping
        </h1>
      </div>

      {/* Form Container */}
      <form>
        <div className="mb-3">
          <label
            className="form-label mb-1"
            htmlFor='keyword'
          >
          Keyword
          </label>
          <input
            className={`form-control`}
            id='keyword'
            type="text"
            placeholder={'検索'}
            onInput={props.handlers.inputText}
          />
        </div>

        {/* if search type is `Distance` */}
        {props.store.searchType === 'distance' &&
          <div className="row">
            <div className="mb-3 col-auto">
              <label className="form-label mb-1">
              Longitude
              </label>
              <input
                className={`form-control`}
                id="grid-last-name"
                type="text"
                placeholder="Click on Map"
                onChange={props.handlers.changeLng}
                value={props.state.inputLng}
              />
            </div>
            <div className="mb-3 col-auto">
              <label className="form-label mb-1">
              Latitude
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Click on Map"
                onChange={props.handlers.changeLat}
                value={props.state.inputLat}
              />
            </div>
          </div>
        }

        {props.store.searchType === 'rect' && (
          <div className='row'>
            <div className="mb-3 col-auto">
              <label className="form-label mb-1">Longitude</label>
              <span className='form-control'>
                {
                    (props.store.rect.maxLngLat[0] && props.store.rect.minLngLat[0]) ?
                    `${Math.round(props.store.rect.minLngLat[0]*100)/100} ~ ${Math.round(props.store.rect.maxLngLat[0]*100)/100}` :
                    'Draw on Map'
                }
              </span>
            </div>
            <div className="mb-3 col-auto">
              <label className="form-label mb-1">Latitude</label>
              <span className='form-control'>
                {
                    (props.store.rect.maxLngLat[1] && props.store.rect.minLngLat[1]) ?
                    `${Math.round(props.store.rect.minLngLat[1]*100)/100} ~ ${Math.round(props.store.rect.maxLngLat[1]*100)/100}` :
                    'Draw on Map'
                }
              </span>
            </div>
          </div>
        )}

        <div className="row justify-content-around mb-4">
          <div className="col-auto">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="checkbox"
                checked={props.store.searchType == 'distance'}
                onChange={() => props.handlers.switchSearchType('distance')}
              />
              <span className="">
                Sort by Distance from Location
              </span>
            </label>
          </div>
          <div className="col-auto">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="checkbox"
                checked={props.store.searchType == 'rect'}
                onChange={() => props.handlers.switchSearchType('rect')}
              />
              <span className="">
                Filter by Rectangle on Map
              </span>
            </label>
          </div>
          <div className="col-3 align-self-center">
            <button
              // className="btn-yellow btn-yellow:hober btn-yellow:hover:before btn-yellow:hover:after btn-lg"
              type="button"
              onClick={props.handlers.search}
              style={{
                border: 'none',
                outline: 'none',
                padding: 0,
                appearance: 'none',
                fontFamily: 'Saira, sans-serif',
                color: 'white',
                background: '#e9bc00',
                borderRadius: '0.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
              }}
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
);

export default View;
